module.exports = __webpack_public_path__ + "img/googlemeet.19e404a6.png";